import { duration, getCalendarDaysBetween } from "../dateUtils.mjs";
import { getEntryTimestampsFromPlatformStorage } from "./getEntryTimestamps.mjs";
function getTemporalUserProperties(analyticsStorage, now, amplitudeTimeZone) {
  const entryTimestamps = getEntryTimestampsFromPlatformStorage(analyticsStorage);
  if (!entryTimestamps) {
    return null;
  }
  return getTemporalUserPropertiesFromEntryTimestamps(
    entryTimestamps,
    now,
    amplitudeTimeZone
  );
}
function getTemporalUserPropertiesFromEntryTimestamps(entryTimestamps, now, amplitudeTimeZone) {
  const {
    firstEntryAt,
    lastEntryAt,
    zeroEntryAt,
    lastAdEntryAt,
    lastResurrectedAt
  } = entryTimestamps;
  const isValid = (!firstEntryAt || typeof firstEntryAt === "number") && typeof lastEntryAt === "number" && (!zeroEntryAt || typeof zeroEntryAt === "number") && (!lastAdEntryAt || typeof lastAdEntryAt === "number") && (!lastResurrectedAt || typeof lastResurrectedAt === "number");
  if (!isValid) {
    return null;
  }
  const DAY_IN_MS = duration({ days: 1 });
  const daysElapsedLastEntry = (now - lastEntryAt) / DAY_IN_MS;
  const temporalUserProps = {
    daysElapsedLastEntry,
    daysSinceLastEntry: Math.floor(daysElapsedLastEntry),
    hoursElapsedLastEntry: daysElapsedLastEntry * 24
  };
  if (firstEntryAt) {
    temporalUserProps.daysElapsedFirstEntry = (now - firstEntryAt) / DAY_IN_MS;
    temporalUserProps.daysSinceInstall = Math.floor(
      (now - firstEntryAt) / DAY_IN_MS
    );
    temporalUserProps.hoursElapsedFirstEntry = (now - firstEntryAt) / duration({ hours: 1 });
    if (amplitudeTimeZone) {
      const projectDaysSinceInstall = getCalendarDaysBetween({
        fromTimestamp: firstEntryAt,
        ianaTimeZone: amplitudeTimeZone,
        toTimestamp: now
      });
      temporalUserProps.projectDaysSinceInstall = projectDaysSinceInstall;
      temporalUserProps.lastEntryCalendarDaysSinceInstall = projectDaysSinceInstall;
    }
  }
  if (lastAdEntryAt) {
    temporalUserProps.daysSinceLastAdEntry = Math.floor(
      (now - lastAdEntryAt) / DAY_IN_MS
    );
  }
  if (lastResurrectedAt) {
    temporalUserProps.daysSinceLastResurrected = Math.floor(
      (now - lastResurrectedAt) / DAY_IN_MS
    );
  }
  if (zeroEntryAt) {
    temporalUserProps.$lastEntryElapsedDaysZeroEntry = (now - zeroEntryAt) / DAY_IN_MS;
    if (amplitudeTimeZone) {
      const projectDaysSinceZeroEntry = getCalendarDaysBetween({
        fromTimestamp: zeroEntryAt,
        ianaTimeZone: amplitudeTimeZone,
        toTimestamp: now
      });
      temporalUserProps.projectDaysSinceZeroEntry = projectDaysSinceZeroEntry;
      temporalUserProps.lastEntryCalendarDaysSinceZeroEntry = projectDaysSinceZeroEntry;
    }
  }
  return temporalUserProps;
}
export {
  getTemporalUserProperties,
  getTemporalUserPropertiesFromEntryTimestamps
};
